import React from 'react';
import '../../styles/styles.css';

export default function madurai() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/madurai.jpg" alt="Meenakshi Temple" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Important Festival Date in Madurai Meenakshi Amman Temple<br />
    Meenakshi Thirukalyanam : April-May 2026 (Tamil month of Chithirai)<br />    
    <br />

  </strong></p>
  <p>Madurai Meenakshi Temple Official Website : <a href="https://maduraimeenakshi.hrce.tn.gov.in/" target="_blank" rel="noopener noreferrer">
  Madurai Meenakshi Website
</a>
</p> 
</div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Meenakshi Temple, also referred to as Meenakshi Amman or Meenakshi Sundareshwara Temple, is a historic Hindu temple located on the southern bank of the Vaigai River in the temple city of Madurai, Tamil Nadu, India.The presiding deities are Meenakshi, a form of Parvati, and her consort, Sundareshwar, a form of Shiva. According to legend, the sacred Suyambulingam discovered by the king of Indhira logam at Kadambavanam, was later enshrined by him in Madurai. The fact that the Lord is seen on the vehicle of Indira in this temple is said to be proof for this. The temple is at the center of the ancient temple city of Madurai mentioned in the Tamil Sangam literature, with the goddess temple mentioned in 6th century CE texts. The restored complex now houses 14 gopurams (gateway towers), ranging from 4550m in height, with the southern gopura tallest at 51.9 metres (170 ft). The complex has numerous sculpted pillared halls such as Ayirakkal (Thousand pillared hall), Kilikoondu-mandapam, Golu-mandapam and Pudu-mandapam.</p>
             </div>
        </div>

        <div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Madurai Meenakshi Temple</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/tYMb4HwyzSc?rel=0&modestbranding=1&showinfo=0"
                title="Madurai Meenakshi Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

  </div>
</div>
</div>

  )
}
